export const initHandleMissingProductFormSubmit = () => {
    $("#missing-product-modal").on("shown.bs.modal", function (event) {
        this.querySelector('[name="product_name"]').focus();
    });

    $(".js-missing-product-request-form").validate({
        submitHandler: function (form) {
            $(".js-missing-product-request-submit").prop("disabled", true).addClass("is-loading");
            $(".js-missing-product-request-error").slideUp(150);

            Form.ajaxPost(
                form,
                function (data) {
                    $(".js-missing-product-request-submit")
                        .prop("disabled", false)
                        .removeClass("is-loading");

                    if (data.status) {
                        $(".js-missing-product-request-form").slideUp(250);
                        $(".js-missing-product-request-success").slideDown(250);
                    } else {
                        $(".js-missing-product-request-error").html(data.message).slideDown(250);
                    }
                },
                "json"
            );
        },
    });
};
